import { BrowserRouter, Routes, Route } from "react-router-dom";

///////////////////// COMPONENTS
import Home from "./components/Home";
import Navbar from "./components/Navbar";
import CodeofConduct from "./components/CodeOfConduct";

const SiteRoutes = () => {
  return (

    <BrowserRouter>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/codeofconduct" element={<CodeofConduct />} />

      </Routes>
    </BrowserRouter>

  )
}

export default SiteRoutes;